module.exports = __webpack_public_path__ + "static/media/read-a-book.d27ba320.png";